module.exports = __webpack_public_path__ + "img/dyeing.46d2a8e5.svg";